const baseStyle = {
  color: `heading`,
  fontFamily: `heading`,
  fontWeight: `bold`,
};

const variants = {
  h1: {
    fontSize: [`4xl`, null, `6xl`],
  },
  h1Shadow: {
    fontSize: [`4xl`, null, `6xl`],
    textShadow: `rgb(0 0 0 / 50%) 0px 3px 6px`,
  },
  h2: {
    fontSize: [`3xl`, null, `5xl`],
  },
  h2Shadow: {
    fontSize: [`3xl`, null, null, `4xl`, `5xl`],
    textShadow: `rgb(0 0 0 / 50%) 0px 3px 6px`,
  },
  h2ShadowSpan: {
    fontSize: [`3xl`, null, null, `4xl`],
    span: {
      textShadow: `rgb(0 0 0 / 50%) 0px 3px 6px`,
      fontSize: [`3xl`, null, `4xl`, `4xl`, `5xl`],
      display: `block`,
    },
  },
  h3: {
    fontSize: [`3xl`, null, `4xl`],
  },
  h3Shadow: {
    fontSize: [`3xl`, null, `4xl`],
    textShadow: `rgb(0 0 0 / 50%) 0px 3px 6px`,
  },
  h4: {
    // fontFamily: `body`,
    fontSize: [`2xl`, null, `3xl`],
  },
  h4Shadow: {
    fontSize: [`2xl`, null, `3xl`],
    textShadow: `rgb(0 0 0 / 50%) 0px 3px 6px`,
  },
  h5: {
    fontFamily: `body`,
    fontSize: [`xl`, null, `2xl`],
  },
  h5Shadow: {
    fontSize: [`xl`, null, `2xl`],
    textShadow: `rgb(0 0 0 / 50%) 0px 3px 6px`,
  },
  h5Gray: {
    fontFamily: `body`,
    fontSize: [`xl`, null, `2xl`],
    color: `gray.lightest`,
    fontWeight: `500 `,
  },
  h6: {
    fontFamily: `body`,
    fontSize: [`lg`, null, `xl`],
  },
};

export const Heading = {
  baseStyle,
  variants,
};
